import { appContent } from '@/mocks/home';

export default function AppSection() {
  return (
    <section id="app" className="py-10 md:py-14 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex flex-col lg:flex-row items-center gap-8 lg:gap-12 bg-background-100 rounded-lg p-6 md:p-10 border border-background-200/70">
          <div className="flex-1 text-center lg:text-left">
            <h2 className="font-heading text-xl md:text-2xl font-bold text-foreground-950 mb-3">
              {appContent.title}
            </h2>
            <p className="text-sm md:text-base text-foreground-600 leading-relaxed mb-5">
              {appContent.subtitle}
            </p>
            <div className="grid grid-cols-2 gap-2">
              {appContent.features.map((feat, idx) => (
                <div key={idx} className="flex items-center gap-2 text-sm text-foreground-700">
                  <span className="w-5 h-5 flex items-center justify-center">
                    <i className="ri-checkbox-circle-fill text-primary-500 text-sm"></i>
                  </span>
                  {feat}
                </div>
              ))}
            </div>
          </div>
          <div className="flex-shrink-0">
            <div className="w-48 h-48 md:w-56 md:h-56 rounded-lg bg-background-200 flex items-center justify-center">
              <div className="text-center">
                <span className="w-14 h-14 flex items-center justify-center mx-auto mb-3">
                  <i className="ri-smartphone-line text-5xl text-primary-500"></i>
                </span>
                <p className="text-xs text-foreground-500">浏览器打开即用</p>
                <p className="text-xs text-foreground-500 mt-1">无需下载安装</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}